import React from "react";

import styles from "../../Klassen/fschein-classes.module.scss";

import bus from "../../Klassen/Static/bus.png";

const Bus = () => {
  return <img className={styles["mobile-bg-img"]} alt="Bus" src={bus}></img>;
};

export default Bus;
